import PalletsTransferHistory from 'components/PalletsTransferHistory/PalletsTransferHistory';
import WithAuth from 'hoc/withAuth';

const PalletsTransferHistoryPage = () => <PalletsTransferHistory mode="ROLE_SYSTEM_ADMIN" />;

export default WithAuth(PalletsTransferHistoryPage, 'ROLE_SYSTEM_ADMIN');
